import { render } from "./MyAssets.vue?vue&type=template&id=27b84904&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"

import "./MyAssets.vue?vue&type=style&index=0&id=27b84904&lang=scss"
import "./MyAssets.vue?vue&type=style&index=1&id=27b84904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b84904"]])

export default __exports__